"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGmailUrl = void 0;
function getGmailUrl(metadata) {
    var from = metadata.from, subject = metadata.subject;
    var searchQuery = encodeURIComponent("from:".concat(from, " \"").concat(subject, "\""));
    return "https://mail.google.com/mail/u/0/#search/".concat(searchQuery);
}
exports.getGmailUrl = getGmailUrl;
